import { Injectable } from '@angular/core';
import { LocalService } from './local.service';
import { CONSTANTS } from '../../config';

@Injectable()
export class AuthService {

  getToken() {
    return LocalService.get('token');
  }

  setToken(token) {
    LocalService.set('token', token);
  }

  flushToken() {
    LocalService.flush('token');
  }

  clearAll() {
    LocalService.flush();
  }

  get isAuthenticated(): boolean {
    const auth = !!(this.accessToken && this.getToken())
    // console.log('isAuthenticated::::::::::::::::', auth)
    return auth
  }

  set accessToken(token) {
    LocalService.set(CONSTANTS.KEYS.ACCESS_TOKEN, token);
  }

  get accessToken() {
    return LocalService.get(CONSTANTS.KEYS.ACCESS_TOKEN);
  }

  set accessTokenExpiry(token) {
    LocalService.set(CONSTANTS.KEYS.ACCESS_TOKEN_EXPIRY, token);
  }

  get accessTokenExpiry() {
    return LocalService.get(CONSTANTS.KEYS.ACCESS_TOKEN_EXPIRY);
  }

  set refreshToken(token) {
    LocalService.set(CONSTANTS.KEYS.REFRESH_TOKEN, token);
  }

  get refreshToken() {
    return LocalService.get(CONSTANTS.KEYS.REFRESH_TOKEN);
  }

  set refershTokenExpiry(token) {
    LocalService.set(CONSTANTS.KEYS.REFRESH_TOKEN_EXPIRY, token);
  }

  get refershTokenExpiry() {
    return LocalService.get(CONSTANTS.KEYS.REFRESH_TOKEN_EXPIRY);
  }

  get idToken() {
    return LocalService.get(CONSTANTS.KEYS.ID_TOKEN);
  }

  set idToken(token) {
    LocalService.set(CONSTANTS.KEYS.ID_TOKEN, token);
  }

  get codeVerifier() {
    return LocalService.get(CONSTANTS.KEYS.CODE_VERIFIER);
  }

  set codeVerifier(code) {
    LocalService.set(CONSTANTS.KEYS.CODE_VERIFIER, code);
  }

  get oidcState() {
    return LocalService.get(CONSTANTS.KEYS.OIDC_STATE);
  }

  set oidcState(state) {
    LocalService.set(CONSTANTS.KEYS.OIDC_STATE, state);
  }

  flushCodeVerifier() {
    LocalService.flush(CONSTANTS.KEYS.CODE_VERIFIER);
  }

  flushOidcState() {
    LocalService.flush(CONSTANTS.KEYS.OIDC_STATE);
  }

  storeTokens(tokens) {
    const currentTime = Math.floor(Date.now() / 1000);
    const accessTokenExpiry = currentTime + tokens.expires_in;
    const refreshTokenExpiry = currentTime + (30 * 24 * 60 * 60); // 30 days

    this.accessToken = tokens.access_token;
    this.accessTokenExpiry = accessTokenExpiry.toString();

    this.refreshToken = tokens.refresh_token;
    this.refershTokenExpiry = refreshTokenExpiry.toString();

    this.idToken = tokens.id_token;
  }

  set userProfile(userProfile) {
    LocalService.set(CONSTANTS.KEYS.USER_PROFILE, userProfile);
  }

  get userProfile() {
    return LocalService.get(CONSTANTS.KEYS.USER_PROFILE);
  }

  set returnUrl(returnUrl) {
    LocalService.set(CONSTANTS.KEYS.RETURN_URL, returnUrl);
  }

  get returnUrl() {
    return LocalService.get(CONSTANTS.KEYS.RETURN_URL);
  }

  flushReturnUrl() {
    LocalService.flush(CONSTANTS.KEYS.RETURN_URL);
  }

}
